import React, { useEffect, useState, useContext } from 'react';
import {
  Box, Paper, Button, TextField,
  Table, TableBody, TableCell, TableContainer, TableHead,
  TableRow, IconButton, MenuItem, InputAdornment, Tooltip,
  TablePagination, Typography
} from '@mui/material';
import {
  Edit, Delete, Search,
  FileDownload, Visibility, HowToReg, WhatsApp
} from '@mui/icons-material';
import HeaderPimpinan from '../components/HeaderPimpinan';
import HeaderPresenter from '../components/HeaderPresenter';
import FormPendaftaranSiswa from '../components/FormPendaftaranSiswa';
import DetailPendaftaranDialog from '../components/DetailPendaftaranDialog';
import FormDaftarUlang from '../components/FormDaftarUlang';
import { AuthContext } from '../context/AuthContext';
import { db } from '../firebase';
import {
  collection, getDocs, query, where, deleteDoc, doc, getDoc
} from 'firebase/firestore';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const monthNames = [
  'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
  'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'
];

const currentDate = new Date();
const currentYear = currentDate.getFullYear();

const PendaftaranSiswa = () => {
  const { userData } = useContext(AuthContext);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState('');
  const [filterGelombang, setFilterGelombang] = useState('');
  const [gelombangList, setGelombangList] = useState([]);
  const [filterCabang, setFilterCabang] = useState('');
  const [kantorList, setKantorList] = useState([]);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [editingData, setEditingData] = useState(null);
  const [sortConfig, setSortConfig] = useState({ key: 'nomorPendaftaran', direction: 'desc' });
  const [openDetail, setOpenDetail] = useState(false);
  const [selectedDetail, setSelectedDetail] = useState(null);
  const [selectedPendaftar, setSelectedPendaftar] = useState(null);
  const [openDrawerDaftarUlang, setOpenDrawerDaftarUlang] = useState(false);
  const [daftarUlangIds, setDaftarUlangIds] = useState([]);
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');
  const [waTemplate, setWaTemplate] = useState('');

  // Pagination states
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // Helper function to parse Indonesian currency format
  const parseCurrency = (value) => {
    if (!value) return 0;
    // Remove all dots and parse as number
    const cleanValue = value.toString().replace(/\./g, '');
    return parseFloat(cleanValue) || 0;
  };

  const handleWhatsApp = (item) => {
    let phone = item.nomorWA || '';
    if (!phone) {
      alert('Nomor WhatsApp tidak tersedia untuk siswa ini.');
      return;
    }
    
    // Format phone number to start with 62
    phone = phone.replace(/\D/g, ''); // Remove non-numeric characters
    if (phone.startsWith('0')) {
      phone = '62' + phone.substring(1);
    }
    
    // Use template and replace placeholders
    let message = waTemplate || `Halo {nama},\n\nKami dari bagian admin pendaftaran. Menghubungi terkait pendaftaran Anda dengan Nomor Pendaftaran: {nomorPendaftaran}. \n\nTerima kasih.`;
    
    message = message.replace(/\{nama\}/g, item.namaPendaftar || '');
    message = message.replace(/\{nomorPendaftaran\}/g, item.nomorPendaftaran || '');
    message = message.replace(/\{asalSekolah\}/g, item.asalSekolah || '');
    message = message.replace(/\{jurusan\}/g, item.jurusan || '');
    message = message.replace(/\{tglDaftar\}/g, item.tglDaftar || '');
    
    const encodedMessage = encodeURIComponent(message);
    const waUrl = `https://wa.me/${phone}?text=${encodedMessage}`;
    
    window.open(waUrl, '_blank');
  };

  const handleDaftarUlangClick = async (item) => {
    // Cek permission untuk presenter
    if (userData?.role === 'presenter') {
      if (item.cabangOffice !== userData.cabangOffice) {
        alert('Anda hanya dapat mengisi daftar ulang untuk siswa dari cabang office Anda.');
        return;
      }
    }

    const snapshot = await getDocs(
      query(collection(db, 'daftar_ulang'), where('idPendaftar', '==', item.id))
    );

    if (!snapshot.empty) {
      alert('Siswa sudah melakukan daftar ulang. Hapus data daftar ulang terlebih dahulu untuk mengisi ulang.');
      return;
    }

    setSelectedPendaftar(item);
    setOpenDrawerDaftarUlang(true);
  };

  useEffect(() => {
    const loadData = async () => {
      if (!userData) return;

      try {
        let result = [];

        if (userData?.role === 'pimpinan') {
          // Pimpinan dapat melihat semua data
          const snapshot = await getDocs(collection(db, 'pendaftaran_siswa'));
          result = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        } else if (userData?.role === 'presenter') {
          if (userData?.cabangOffice) {
            // Presenter hanya bisa melihat data sesuai cabangOffice mereka
            const query1 = query(
              collection(db, 'pendaftaran_siswa'),
              where('cabangOffice', '==', userData.cabangOffice)
            );

            const snapshot = await getDocs(query1);
            result = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
          } else {
            // Jika presenter tidak memiliki cabangOffice, tidak tampilkan data apapun
            result = [];
          }
        } else {
          // Fallback: jika role tidak dikenali atau data user tidak lengkap
          setData([]);
          setDaftarUlangIds([]);
          return;
        }

        // Ambil data daftar ulang
        const daftarUlangSnap = await getDocs(collection(db, 'daftar_ulang'));
        const daftarUlangList = daftarUlangSnap.docs.map(doc => doc.data().nomorPendaftaran);

        setData(result);
        setDaftarUlangIds(daftarUlangList);
      } catch (error) {
        alert('Gagal memuat data. Silakan coba lagi.');
      }
    };
    const fetchWaTemplate = async () => {
      try {
        const docRef = doc(db, 'settings', 'wa_template');
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setWaTemplate(docSnap.data().template);
        }
      } catch (error) {
        console.error('Error fetching WA template:', error);
      }
    };

    fetchGelombang();
    fetchKantor();
    loadData();
    fetchWaTemplate();
  }, [userData]);

  // Reset pagination when filters change
  useEffect(() => {
    setPage(0);
  }, [search, filterGelombang, filterCabang, month, year]);

  const fetchGelombang = async () => {
    const snapshot = await getDocs(collection(db, 'gelombang'));
    const result = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setGelombangList(result);
  };

  const fetchKantor = async () => {
    const snapshot = await getDocs(collection(db, 'kantor'));
    const result = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setKantorList(result);
  };

  const fetchData = async () => {
    if (!userData) return;

    try {
      let result = [];

      if (userData?.role === 'pimpinan') {
        // Pimpinan dapat melihat semua data
        const snapshot = await getDocs(collection(db, 'pendaftaran_siswa'));
        result = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      } else if (userData?.role === 'presenter' && userData?.cabangOffice) {
        // Presenter hanya bisa melihat data dari cabangOffice yang sama
        const snapshot = await getDocs(
          query(
            collection(db, 'pendaftaran_siswa'),
            where('cabangOffice', '==', userData.cabangOffice)
          )
        );
        result = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        } else {
          // Fallback: jika role tidak dikenali atau data user tidak lengkap
          setData([]);
          setDaftarUlangIds([]);
          return;
        }      // Ambil data daftar ulang
      const daftarUlangSnap = await getDocs(collection(db, 'daftar_ulang'));
      const daftarUlangList = daftarUlangSnap.docs.map(doc => doc.data().nomorPendaftaran);

      setData(result);
      setDaftarUlangIds(daftarUlangList);
    } catch (error) {
      alert('Gagal memuat data. Silakan coba lagi.');
    }
  };

  const handleEdit = (row) => {
    // Cek permission untuk presenter
    if (userData?.role === 'presenter') {
      if (row.cabangOffice !== userData.cabangOffice) {
        alert('Anda hanya dapat mengedit data siswa dari cabang office Anda.');
        return;
      }
    }

    setEditingData(row);
    setOpenDrawer(true);
  };

  const handleDelete = async (id, nomorPendaftaran, row) => {
    // Cek permission untuk presenter
    if (userData?.role === 'presenter') {
      if (row.cabangOffice !== userData.cabangOffice) {
        alert('Anda hanya dapat menghapus data siswa dari cabang office Anda.');
        return;
      }
    }

    if (daftarUlangIds.includes(nomorPendaftaran)) {
      alert('Tidak bisa menghapus. Siswa ini sudah melakukan daftar ulang. Hapus data daftar ulang terlebih dahulu.');
      return;
    }

    const confirm = window.confirm('Yakin ingin menghapus data ini?');
    if (!confirm) return;

    await deleteDoc(doc(db, 'pendaftaran_siswa', id));
    fetchData();
  };

  const handleSort = (key) => {
    setSortConfig(prev => {
      if (prev.key === key) {
        return { key, direction: prev.direction === 'asc' ? 'desc' : 'asc' };
      } else {
        return { key, direction: 'asc' };
      }
    });
  };

  const sortedData = [...data].sort((a, b) => {
    if (!sortConfig.key) return 0;

    // Special handling for date sorting
    if (sortConfig.key === 'tglDaftar') {
      const aDate = new Date(a.tglDaftar);
      const bDate = new Date(b.tglDaftar);
      if (sortConfig.direction === 'asc') {
        return aDate - bDate;
      } else {
        return bDate - aDate;
      }
    }

    // Default string sorting for other fields
    const aVal = a[sortConfig.key]?.toString().toLowerCase();
    const bVal = b[sortConfig.key]?.toString().toLowerCase();
    if (aVal < bVal) return sortConfig.direction === 'asc' ? -1 : 1;
    if (aVal > bVal) return sortConfig.direction === 'asc' ? 1 : -1;
    return 0;
  });

  const filteredData = sortedData.filter((item) => {
    const keyword = search.toLowerCase();
    const matchesSearch = (
      item.namaPendaftar?.toLowerCase().includes(keyword) ||
      item.nomorPendaftaran?.toLowerCase().includes(keyword) ||
      item.asalSekolah?.toLowerCase().includes(keyword)
    );
    const matchesGelombang = !filterGelombang || item.idGelombang === filterGelombang;
    const matchesCabang = !filterCabang || item.cabangOffice === filterCabang;

    // Filter by month and year if selected
    let matchesMonthYear = true;
    if (item.tglDaftar) {
      const [itemYear, itemMonth] = item.tglDaftar.split('-');
      matchesMonthYear =
        (!month || parseInt(itemMonth) === parseInt(month)) &&
        (!year || parseInt(itemYear) === parseInt(year));
    }
    return matchesSearch && matchesGelombang && matchesCabang && matchesMonthYear;
  });

  // Get paginated data for display
  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  // Generate year options start from 2020 to current year desc
  const yearOptions = [];
  for (let y = currentYear; y >= 2020; y--) {
    yearOptions.push(y);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleExport = async () => {
    // Export uses filteredData (all filtered data, not paginated)
    const exportData = filteredData.map(item => {
      const gel = gelombangList.find(g => g.id === item.idGelombang);

      // Format currency values for better readability
      const formatCurrency = (value) => {
        if (!value) return 0;
        const numValue = parseInt(value.toString().replace(/\./g, '')) || 0;
        return numValue.toLocaleString('id-ID');
      };

      return {
        'Nomor Pendaftaran': item.nomorPendaftaran || '',
        'Tanggal Daftar': item.tglDaftar || '',
        'ID Gelombang': item.idGelombang || '',
        'Nama Gelombang': gel?.namaGelombang || '(tidak ditemukan)',
        'Nama Pendaftar': item.namaPendaftar || '',
        'Nomor WA': item.nomorWA || '',
        'Email': item.email || '',
        'Asal Sekolah': item.asalSekolah || '',
        'Jurusan': item.jurusan || '',
        'Kode Jurusan': item.jurusanKode || '',
        'Nama Jurusan': item.jurusanNama || '',
        'Biaya Jurusan': formatCurrency(item.biayaJurusan),
        'Biaya Pendaftaran': item.biayaPendaftaran || '',
        'Jalur Pendaftaran': item.jalurPendaftaran || '',
        'No Kwitansi': item.noKwitansi || '',
        'Presenter': Array.isArray(item.presenter) ? item.presenter.join(', ') : (item.presenter || ''),
        'Cara Daftar': item.caraDaftar || '',
        'Keterangan': item.ket || '',
        'Cabang Office': item.cabangOffice || '',
        'Jenis Potongan': item.jenisPotongan || 'Tanpa Potongan',
        'Jumlah Potongan': formatCurrency(item.jumlahPotongan),
        'Total Biaya Pendaftaran': formatCurrency(item.totalBiayaPendaftaran || item.biayaPendaftaran),
        'Total Biaya Jurusan': formatCurrency(item.totalBiayaJurusan || item.biayaJurusan),
        'Sumber Informasi': item.sumberInformasi || '',
        'ID Pendaftaran': item.idPendaftaran || item.id || ''
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Pendaftar');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    // Create filename with current filters for clarity
    let filename = 'pendaftaran_siswa';
    if (filterGelombang) {
      const gelombang = gelombangList.find(g => g.id === filterGelombang);
      filename += `_${gelombang?.namaGelombang || 'gelombang'}`;
    }
    if (month) {
      filename += `_${monthNames[month - 1]}`;
    }
    if (year) {
      filename += `_${year}`;
    }
    filename += '.xlsx';

    saveAs(new Blob([excelBuffer], { type: 'application/octet-stream' }), filename);
  };

  return (
    <Box>
      {userData?.role === 'pimpinan' ? <HeaderPimpinan /> : <HeaderPresenter />}
      <Box sx={{ p: 4 }}>
        <Paper sx={{ p: 2, mb: 2, display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
          {/* Tombol Tambah Data - hanya untuk pimpinan atau sesuai kebijakan */}
          {(userData?.role === 'pimpinan' || userData?.role === 'presenter') && (
            <Button variant="contained" onClick={() => { setOpenDrawer(true); setEditingData(null); }}>
              Tambah Data
            </Button>
          )}
          <Button variant="outlined" startIcon={<FileDownload />} onClick={handleExport}>
            Export Excel ({filteredData.length} data)
          </Button>
          <TextField
            label="Cari..."
            variant="outlined"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              )
            }}
          />
          <TextField
            select
            label="Filter Gelombang"
            value={filterGelombang}
            onChange={(e) => setFilterGelombang(e.target.value)}
            sx={{ minWidth: 200 }}
          >
            <MenuItem value="">Semua Gelombang</MenuItem>
            {gelombangList.map(g => (
              <MenuItem key={g.id} value={g.id}>{g.namaGelombang}</MenuItem>
            ))}
          </TextField>
          {userData?.role === 'pimpinan' && (
            <TextField
              select
              label="Cabang"
              value={filterCabang}
              onChange={(e) => setFilterCabang(e.target.value)}
              sx={{ minWidth: 150 }}
            >
              <MenuItem value="">Semua Cabang</MenuItem>
              {kantorList.map(k => (
                <MenuItem key={k.id} value={k.namaKantor}>{k.namaKantor}</MenuItem>
              ))}
            </TextField>
          )}
          <TextField
            select
            label="Bulan"
            value={month}
            onChange={e => setMonth(e.target.value === '' ? '' : Number(e.target.value))}
            sx={{ minWidth: 120 }}
          >
            <MenuItem value="">Semua Bulan</MenuItem>
            {monthNames.map((name, idx) => (
              <MenuItem key={idx + 1} value={idx + 1}>{name}</MenuItem>
            ))}
          </TextField>
          <TextField
            select
            label="Tahun"
            value={year}
            onChange={e => setYear(e.target.value === '' ? '' : Number(e.target.value))}
            sx={{ minWidth: 100 }}
          >
            <MenuItem value="">Semua Tahun</MenuItem>
            {yearOptions.map(y => (
              <MenuItem key={y} value={y}>{y}</MenuItem>
            ))}
          </TextField>
        </Paper>

        <Paper>
          <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box>
              <Typography variant="h6">
                Data Pendaftaran Siswa
              </Typography>
              {userData?.role === 'presenter' && userData?.cabangOffice && (
                <Typography variant="body2" color="primary" sx={{ mt: 0.5 }}>
                  Filter: {userData.cabangOffice}
                </Typography>
              )}
              {userData?.role === 'presenter' && !userData?.cabangOffice && (
                <Typography variant="body2" color="error" sx={{ mt: 0.5 }}>
                  Peringatan: Anda belum memiliki cabang office yang terdaftar
                </Typography>
              )}
            </Box>
            <Typography variant="body2" color="text.secondary">
              Menampilkan {paginatedData.length} dari {filteredData.length} data
            </Typography>
          </Box>

          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>No</TableCell>
                  <TableCell
                    onClick={() => handleSort('nomorPendaftaran')}
                    sx={{ cursor: 'pointer', userSelect: 'none' }}
                  >
                    Nomor Pendaftaran
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort('namaPendaftar')}
                    sx={{ cursor: 'pointer', userSelect: 'none' }}
                  >
                    Nama
                  </TableCell>
                  <TableCell>WA</TableCell>
                  <TableCell
                    onClick={() => handleSort('asalSekolah')}
                    sx={{ cursor: 'pointer', userSelect: 'none' }}
                  >
                    Sekolah
                  </TableCell>
                  <TableCell>Jurusan</TableCell>
                  <TableCell>Tgl Daftar</TableCell>
                  <TableCell>Jenis Potongan</TableCell>
                  <TableCell>Total Biaya Pendaftaran</TableCell>
                  <TableCell align="center">Aksi</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedData.map((item, index) => (
                  <TableRow key={item.id}>
                    <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                    <TableCell>{item.nomorPendaftaran}</TableCell>
                    <TableCell>{item.namaPendaftar}</TableCell>
                    <TableCell>{item.nomorWA}</TableCell>
                    <TableCell>{item.asalSekolah}</TableCell>
                    <TableCell sx={{ maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis'}}>{item.jurusan}</TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>{item.tglDaftar}</TableCell>
                    <TableCell>{item.jenisPotongan || 'Tanpa Potongan'}</TableCell>
                    <TableCell align='center'>
                      Rp {parseCurrency(item.totalBiayaPendaftaran).toLocaleString('id-ID')}
                    </TableCell>
                    <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
                      <Tooltip title="Edit Data Pendaftaran">
                        <IconButton onClick={() => handleEdit(item)}>
                          <Edit fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Hubungi via WhatsApp">
                        <IconButton onClick={() => handleWhatsApp(item)} sx={{ color: '#25D366' }}>
                          <WhatsApp fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Hapus Data">
                        <IconButton onClick={() => handleDelete(item.id, item.nomorPendaftaran, item)}>
                          <Delete fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Lihat Detail">
                        <IconButton onClick={() => { setSelectedDetail(item); setOpenDetail(true); }}>
                          <Visibility fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Isi Form Daftar Ulang">
                        <IconButton
                          onClick={() => handleDaftarUlangClick(item)}
                          color={daftarUlangIds.includes(item.nomorPendaftaran) ? 'primary' : 'default'}
                        >
                          <HowToReg fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
                {paginatedData.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={9} align="center">
                      <Typography variant="body2" color="text.secondary">
                        Tidak ada data yang ditemukan
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            component="div"
            count={filteredData.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25, 50, 100]}
            labelRowsPerPage="Baris per halaman:"
            labelDisplayedRows={({ from, to, count }) =>
              `${from}-${to} dari ${count !== -1 ? count : `lebih dari ${to}`}`
            }
          />
        </Paper>
      </Box>

      <FormPendaftaranSiswa
        open={openDrawer}
        onClose={() => { setOpenDrawer(false); setEditingData(null); }}
        fetchData={fetchData}
        editingData={editingData}
      />

      <DetailPendaftaranDialog
        open={openDetail}
        onClose={() => setOpenDetail(false)}
        data={selectedDetail}
      />

      <FormDaftarUlang
        open={openDrawerDaftarUlang}
        onClose={() => {
          setOpenDrawerDaftarUlang(false);
          setSelectedPendaftar(null);
        }}
        dataPendaftar={selectedPendaftar}
        isEditData={false}
        fetchDaftarUlang={fetchData}
      />
    </Box>
  );
};

export default PendaftaranSiswa;
